angular.module('terminalApp.nabLuckyXUi').controller('LuckyXController', function (
  $scope,
  SevenGamesSvc
) {
  $scope.activeGame = SevenGamesSvc.getGame('LuckyX');
  $scope.activeBets = $scope.activeGame.getBettingSvc();
});
